import { render, staticRenderFns } from "./ViewBill.vue?vue&type=template&id=67d97dec&scoped=true"
import script from "./ViewBill.vue?vue&type=script&lang=js"
export * from "./ViewBill.vue?vue&type=script&lang=js"
import style0 from "./ViewBill.vue?vue&type=style&index=0&id=67d97dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d97dec",
  null
  
)

export default component.exports